<div class="container" *ngIf="!isForm">
  <input type="checkbox" (click)="onClick($event)" [checked]="value" />
  <label>{{ label }}</label>
</div>

<div class="container" *ngIf="isForm">
  <input [formControl]="control" type="checkbox" />
  <label>{{ control["rawValue"].label }}</label>
</div>
